import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../../../apollo-client';
import {appHistory} from '../../../../history';
import {store} from '../../../../store';

import {UserAiFeatures} from './user-ai-features';

export function mountUserAiFeatures(userId: string) {
    const userAiFeaturesMount = document.getElementById('ai-features-mount-for-react');

    if (userAiFeaturesMount) {
        ReactDOM.render(
            <Provider store={store}>
                <ApolloProvider client={nutApolloClient}>
                    <ReactHooksApolloProvider client={nutApolloClient}>
                        <Router history={appHistory}>
                            <UserAiFeatures userId={userId} />
                        </Router>
                    </ReactHooksApolloProvider>
                </ApolloProvider>
            </Provider>,
            userAiFeaturesMount
        );
    }
}
